import React, { Component } from 'react';

//import CornerLabel from '../../components/block/cornerLabel';

import css from './submit.scss';

export default class AccountBlockSubmit extends Component {

	constructor(props) {
		super();
	}

	render() {
		return (
			<div className='account-block-submit pixel-pattern pixel-pattern--01'>
				<div className='push5 push0-mobile account-block-submit__content'>
					{this.props.children}
				</div>

				<div className='cf'></div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/block/submit.js
 **/